import { Proposer, ProposerPerson } from '@acorn-portal/shared/src/services/subscriptionAPI';
import { IFormChangeAddress } from './get-address-initial-values';

export const getProposerDetails = (values: IFormChangeAddress, existingProposer: Proposer): Proposer => {
	return {
		...existingProposer,
		person: {
			...(existingProposer.person as ProposerPerson),
			isHomeOwner: values.isHomeOwner === 'yes' ? true : false,
		},
		address: {
			line1: values.address.line1,
			line2: values.address.line2 ?? undefined,
			line3: values.address.line3 ?? undefined,
			line4: values.address.line4 ?? undefined,
			city: values.address.city,
			postcode: values.address.postcode,
		},
	};
};
